import React from 'react'

function RolesAndPermissions() {
  return (
    <div>RolesAndPermissions</div>
  )
}

export default RolesAndPermissions